<div class="container-fluid justify-content-center text-center">
  <section>
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="notfound" *ngFor="let Content of errorContent">
            <img [src]="Content.img" alt="image" />
            <h3>{{ Content.title }}</h3>
            <p>{{ Content.paragraph }}</p>
            <a routerLink="/" class="default-btn"> BACK TO HOMEPAGE</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
